import {Col, Form, Input, Row} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import InputDocumento from '../../../../../components/input-documento';
import InputNumber from '../../../../../components/input-number';
import InputRazaoSocial from '../../../../../components/input-razao-social';
import MiniForm from '../../../../../components/mini-form';
import {useDebouncedEffect} from '../../../../../hooks/useDebouncedEffect';

export default function EmpresaSocioForm8({disabled, form, loading, onFinish, title}) {
  const {t} = useTranslation();

  useDebouncedEffect(100, () => {
    if (loading === false)
      form.setFieldsValue({exterior: false, capitalQuantidade2: 0, capitalValorUnitario: 0});
  }, [loading]);

  return (
      <MiniForm form={form} loading={loading} onFinish={onFinish}>
        {title}
        <Row gutter={[16, 8]}>
          <Col flex="200px">
            <Form.Item name="documento" label={t('CPF/CNPJ')}>
              <InputDocumento disabled={disabled} />
            </Form.Item>
          </Col>
          <Col flex="400px">
            <Form.Item name="nome" label={t('Nome')}>
              <InputRazaoSocial disabled={disabled} />
            </Form.Item>
          </Col>
          <Col flex="400px">
            <Form.Item name="email" label={t("email")}>
              <InputRazaoSocial disabled={disabled} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 8]}>
          <Col flex="200px">
            <Form.Item name="capitalQuantidade" label={t('Quotas')}>
              <InputNumber disabled={disabled} maximumFractionDigits={2} minimumFractionDigits={2} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 8]}>
          <Col flex="800px">
            <Form.Item name="obs" label={t('Observação')}>
              <Input.TextArea autoSize disabled={disabled} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="capitalQuantidade2" noStyle initialValue={0} />
        <Form.Item name="capitalValorUnitario" noStyle initialValue={0} />
      </MiniForm>);
}

EmpresaSocioForm8.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.object,
  loading: PropTypes.bool,
  onFinish: PropTypes.func,
  title: PropTypes.node,
};
